import { mdiCalendar, mdiTimerSandEmpty, mdiWrenchOutline } from '@mdi/js'

import { IApproval, ICompliance, TServiceNowChangesStates } from '@/types/tasksApprovals'

export const isSailPointCert = (item: IApproval | ICompliance) => {
    return item.system_id === 'SAIL_POINT_CERT'
}

export const isSailPointCertDecision = (item: IApproval | ICompliance) => {
    return item.system_id === 'SAIL_POINT_CERT_DECISION'
}

export const isServiceNowChangeRequests = (item: IApproval | ICompliance) => {
    return ['SERVICE_NOW_CHANGES', 'SCHEDULED_CHANGE_REQUESTS'].includes(item.system_id)
}

export const isSapGrcAccessReques = (item: IApproval | ICompliance) => {
    return item.system_id === 'SAP_GRC_ACCESS_REQUEST'
}

export const isSapLeaveRequest = (item: IApproval | ICompliance) => {
    return item.system_id === 'SAP_LEAVE_REQUEST'
}

export const isFieldglassTimesheet = (item: IApproval | ICompliance) => {
    return item.system_id === 'FIELDGLASS_TIMESHEET'
}

export const isFieldglassOutsourcedWorker = (item: IApproval | ICompliance) => {
    return item.system_id === 'FIELDGLASS_COMPLEMENTARY_WORKER'
}

export const isTNE = (item: IApproval | ICompliance) => {
    return item.system_id === 'TNE'
}

export const getServiceNowChangeReqIcon = (item: IApproval | ICompliance) => {
    let icon: string
    const state = item?.metadata?.state as TServiceNowChangesStates
    switch (state) {
        case 'Assess':
        case 'Authorize':
        case 'Scheduled':
            icon = mdiCalendar
            break
        case 'Implement':
            icon = mdiWrenchOutline
            break
        case 'Review':
            icon = mdiTimerSandEmpty
            break
        default:
            icon = mdiCalendar
    }
    return icon
}

export const isCompliance = (item: IApproval | ICompliance) => {
    if ('compliance_original_id' in item) return true
    return false
}
